import invalidDateOfBirth  from "./invalid-dateofbirth.html";
import invalidPhoneNumber  from "./invalid-phone-number.html";
import submittedRequest  from "./submitted-request.html";

export default {
	invalid: {
		phoneNumber: invalidPhoneNumber,
		dateOfBirth: invalidDateOfBirth
	},
	submitted: submittedRequest
};